
export enum AnalyticsUserProperties
{
    DemoAccount = "demo_account"
}
